
import React from 'react';
import { Target, Zap, ShieldCheck, ClipboardCheck } from 'lucide-react';

const ProofOfWork: React.FC = () => {
  return (
    <section className="py-24 bg-[#0F1419] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-7xl font-black mb-4 uppercase text-white italic tracking-tighter">This Is The Work</h2>
          <p className="text-xl text-[#1A4D2E] font-black uppercase tracking-widest italic">We Handle The Follow-Up. You Handle The Trees.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Authentic Field Image 1 */}
          <div className="relative group rounded-[2.5rem] overflow-hidden border-4 border-[#1A4D2E]/30 aspect-[4/3] shadow-2xl">
            <img 
              src="https://storage.googleapis.com/msgsndr/RFigwwpXwgFKDDWbFLQd/media/695494cf035c3a5813fc8f24.jpg" 
              alt="Professional tree service operation in the field" 
              className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 transform group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F1419] via-transparent to-transparent opacity-80 group-hover:opacity-60 transition-opacity" />
            <div className="absolute bottom-0 left-0 p-10">
              <h3 className="text-3xl font-black text-white uppercase italic tracking-tighter mb-2">You Focus On Trees</h3>
              <p className="text-[#FF6B35] font-black uppercase tracking-widest text-xs">While our system books your calendar 24/7</p>
            </div>
          </div>

          {/* Authentic Field Image 2 */}
          <div className="relative group rounded-[2.5rem] overflow-hidden border-4 border-[#4E3629]/30 aspect-[4/3] shadow-2xl">
            <img 
              src="https://storage.googleapis.com/msgsndr/RFigwwpXwgFKDDWbFLQd/media/6954954a748303c2495304f9.jpg" 
              alt="Heavy equipment removing large root ball" 
              className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 transform group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F1419] via-transparent to-transparent opacity-80 group-hover:opacity-60 transition-opacity" />
            <div className="absolute bottom-0 left-0 p-10">
              <h3 className="text-3xl font-black text-white uppercase italic tracking-tighter mb-2">We Focus On Leads</h3>
              <p className="text-[#FF6B35] font-black uppercase tracking-widest text-xs">Automated follow-up that never misses a quote</p>
            </div>
          </div>
        </div>

        <div className="mt-20 text-center max-w-4xl mx-auto">
          <p className="text-2xl md:text-3xl font-black text-white/90 italic leading-tight">
            "Real work. Real systems. Real results. From someone who's been in the bucket and scaled to 7 figures. This isn't theory—it's proven in the field."
          </p>
          <div className="mt-8 inline-flex items-center gap-4 bg-[#1A4D2E]/20 px-8 py-4 rounded-full border border-[#1A4D2E]/40">
            <span className="w-3 h-3 bg-[#FF6B35] rounded-full animate-pulse" />
            <span className="text-sm font-black text-[#F4E4C1] uppercase tracking-widest">Built For The Trade, By The Trade</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProofOfWork;
